const crud = { c: false, r: false, u: false, d: false };

export const apis = Object.freeze({
  api: { ...crud },
  apiKey: { ...crud },
});
